/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

import { Collapse as ReactCollapse } from '@material-ui/core';

import colors from '~/styles/colors';

import { Container, CollapseHeader } from './styles';

interface CollapseProps {
  label: string;
  children?: JSX.Element;
  defaultOpen?: boolean;
}

const Collapse: React.FC<CollapseProps> = ({
  label,
  children,
  defaultOpen = true,
}) => {
  const ICON_PROPS = {
    size: 24,
    color: colors.primary,
  };

  const [isOpened, setOpen] = useState(defaultOpen);

  const toggleCollapse = () => {
    setOpen(!isOpened);
  };

  return (
    <Container>
      <CollapseHeader onClick={toggleCollapse}>
        {isOpened ? (
          <MdKeyboardArrowUp {...ICON_PROPS} />
        ) : (
          <MdKeyboardArrowDown {...ICON_PROPS} />
        )}
        <span>{label}</span>
      </CollapseHeader>
      <ReactCollapse in={isOpened}>{children}</ReactCollapse>
    </Container>
  );
};

export default Collapse;
